<style lang="less" scoped>
@import "../../assets/css/common.less";
.searchData {
  padding-top: 45px;
}
.datas p {
  line-height: 20px;
  font-size: 0.83333rem;
  color: #6d6d6d;
  span {
    font-size: 0.83333rem !important;
  }
}

.resourceType {
  color: red;
  margin-right: 5px;
}
</style>
<template>
  <div>
    <div class="searchData">
      <div class="header">
        <div class="search">
          <Input
            type="text"
            :placeholder="$t('organ.resourceName')"
            v-model="resourceName"
            search
            @keyup.enter.native="search"
            @on-search="search"
          />
        </div>
      </div>
      <van-list
        v-if="resolveData.length > 0"
        class="van-list"
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="handleNewData"
      >
        <van-cell
          class="datas"
          v-for="(item, index) in resolveData"
          :key="index"
        >
          <p class="title" v-if="item.resourceChineseName">
            <a @click="registerDetail(item)">{{ item.resourceChineseName }}</a>
          </p>
          <p>
            {{ item.resolve_time.substring(0, 10) }}
          </p>

          <p v-if="item.nameZh">
            {{ item.nameZh }}
          </p>

          <p class="identify">
            <a
              class="date links"
              :href="'https://cstr.cn/' + $checkPrefix(item.identifier)"
              target="_blank"
            >
              <img class="link" src="@/assets/images/nav.png" />CSTR:{{
                item.identifier.replace("CSTR:", "")
              }}
            </a>
          </p>
          <p>
            <span v-if="lang != 'en'"
              >{{ $t("diss.diss10") }}
              <span v-if="item.country == '中国'"
                >{{ item.country
                }}<span v-if="item.province">{{
                  item.province.replaceAll("省", "")
                }}</span></span
              ><span v-if="item.country != '中国'">{{ item.country }}</span>
              <!-- {{ item.country }} -->
            </span>

            <span v-else>{{ $t("diss.diss10") }}{{ item.countryEn }}</span
            >&nbsp;|&nbsp;<span
              >{{ $t("diss.diss11") }}{{ item.resolve_count }}</span
            >
          </p>
        </van-cell>
      </van-list>
      <noData v-else></noData>
    </div>
  </div>
</template>
<script>
import { Indicator } from "mint-ui";
import noData from "../nodata.vue";
export default {
  components: {
    noData,
  },

  data() {
    return {
      resolveData: [],
      loading: false,
      finished: false,
      page: 1,
      resourceName: "",
      size: 10,
    };
  },
  mounted() {
    Indicator.open({
      text: "loading...",
      spinnerType: "fading-circle",
    });
    this.handleNewData();
  },
  methods: {
    registerDetail(item) {
      var link = "/detail?identifier=" + item.identifier;
      window.open(link, "_blank");
    },
    handleNewData() {
      var params = {
        page: this.page,
        size: this.size,
        title: this.resourceName,
      };

      this.$api.getNewResolve(params).then((res) => {
        if (res.status == 200) {
          Indicator.close();
          const results = res.data.items;
          this.page++;
          this.loading = false;
          this.resolveData = this.resolveData.concat(results);
          if (results.length === 0) {
            this.finished = true;
          }
        } else if (res.data.code == 500) {
          Indicator.close();
          this.$Notice.warning({
            title: res.data.message,
          });
        }
      });
    },
    search() {
      this.resolveData = [];
      this.page = 1;
      this.handleNewData();
    },
  },
};
</script>